import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import Permission from "Components/Common/Permission";
import CapacityAssessmentsImportWizard from "./CapacityAssessmentsImportWizard/CapacityAssessmentsImportWizard";

const CapacityAssessmentsImportModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
}> = ({ isOpen, toggle }) => {
  return (
    <Modal
      id="capacity-assessments-import-modal"
      size="xl"
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="data-import-modal"
    >
      <ModalHeader className="p-3 border-bottom" toggle={toggle}>
        <div className="d-flex align-items-center gap-3">
          <div
            className="rounded-2 d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 42, height: 42, background: "#eef2ff" }}
          >
            <i className="ri-file-edit-line" style={{ fontSize: 22, color: "#4361ee" }} />
          </div>
          <div>
            <div className="fw-semibold" style={{ fontSize: 16, lineHeight: 1.3 }}>
              Import Capacity Assessments
            </div>
            <div className="text-muted fw-normal" style={{ fontSize: 14, marginTop: 2 }}>
              Upload a CSV file to bulk-import capacity assessment records
            </div>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="p-4">
        <Permission resource="capacity-assessment" action="import">
          <CapacityAssessmentsImportWizard />
        </Permission>
      </ModalBody>
    </Modal>
  );
};

export default CapacityAssessmentsImportModal;
